import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import Breadcrumb from "../../Component/breadcrumb/Breadcrumb";
import "../ProductDetail/style/ProductDetialsbox.css";
import GalleryImage from "./GalleryImage";
import SpecifIcation from "../../Component/Common/SpecifIcation";
import CartList from "../cart/CartList";
import MobileFilterPdp from "../../Component/Layout/MobileFilter/MobileFilterPdp";
import ProductShortingcollection from "../../Component/Common/ProductShortingcollection";
import SearchMobile from "../../Component/search/SearchMobile";
import SearchFilter from "../../Component/search/SearchFilter";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { getProductDetails } from "./service/productdetails.service";

function ProductDetails() {
  const { slug } = useParams();
  const [products, setProducts] = useState([]);
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  // Filter products by Design + Shade
  const filteredProducts = products.filter((item) => {
    const keyword = search.trim().toLowerCase();

    if (!keyword) return true;

    const design = item.design?.toLowerCase() || "";
    const shade = item.shade?.toLowerCase() || "";
    const designShade = `${design} ${shade}`;

    return (
      design.includes(keyword) ||
      shade.includes(keyword) ||
      designShade.includes(keyword)
    );
  });


  useEffect(() => {
    if (slug) {
      loadProduct(slug);
    }
  }, [slug]);

  const loadProduct = async (productSlug) => {
    setLoading(true);

    try {
      const data = await getProductDetails(productSlug);
       setProducts(data || []);

      if (data && data.length > 0) {
        setSelectedImage(data[0].image_path);
        setSelectedProduct(data[0]);
      } else {
        setSelectedImage("");
        setSelectedProduct(null);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };
  const handleImageClick = (item) => {
    setSelectedImage(item.image_path);
    setSelectedProduct(item);
  };



  

  return (

    <SkeletonTheme baseColor="#e0e0e0" highlightColor="#f5f5f5">
      <Breadcrumb />
      <section className="Product-Detials-box">
        <div className="container">
          <div className="row">
            <div className="col-md-4 col-md-myyy-4">
                <GalleryImage
                      mainimage={selectedImage}
                      quality_name={selectedProduct?.quality_name}
                      design={selectedProduct?.design}
                      shade={selectedProduct?.shade}
                      images={selectedProduct?.images || []}
                    />
              {loading ? (
                <Skeleton height={30}/>
              ) : (
                 <SpecifIcation description={products.length > 0 ? products[0].description : ""} />
              )}
            </div>

            <div className="col-md-8 col-md-myyy-8">
              <div className="box-rtoresponcive">
                <div className="row">
                  <div className="col-md-1 col-2">
                    <Link to="/productgraid"
                        className="text-3xl text-gray-400"
                        style={{ color:"rgb(248 163 120 / 92%)"}}
                        title="Go to Grid"
                         state={{ products }} // ✅ IMPORTANT FIX
                     >
                      <i className="bi bi-grid-3x3-gap-fill"></i>
                    </Link>

                   {/* {!loading && (
                      <Link
                        to="/productgraid"
                        className="text-3xl text-gray-400"
                        style={{ color:"#a9a3a3"}}
                        title="Go to Grid"
                         state={{ products: productitems }}
                      >
                         <i class="bi bi-grid"></i>
                      </Link>
                    )} */}
                  </div>

                  <div className="col-md-7 col-3 col-md-7-horizental">
                    <div className="Filter-Desk">

                        <SearchFilter
                          search={search}
                          setSearch={setSearch}
                        />

                    </div>
                    <div className="Filtermobilesearch">
                        <SearchMobile/>
                    </div>
                  </div>

                  <div className="col-md-4 col-7 col-md-4-horizental">
                    <div className="d-flex justify-content-end">
                           <ProductShortingcollection/>
                      <div className="Filtermobile" style={{ marginTop:"5px"}}>
                           <MobileFilterPdp/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

             <div className="all-images-box mt-3">
  <div className="row row-cols-3 row-cols-md-4 row-cols-lg-4 row-cols-xl-5 g-2 text-center">
    {loading ? (
      Array.from({ length: 10 }).map((_, index) => (
        <div className="col" key={index}>
          <Skeleton height={180} />
        </div>
      ))
    ) : (
      filteredProducts.map((item, index) => (
        <div className="col" key={index}>
          <div
            className="boximg"
            onClick={() => handleImageClick(item)}
            style={{
              cursor: "pointer",
              border:
                selectedImage === item.image_path
                  ? "2px solid #f8a378"
                  : "",
              borderRadius: "5px",
              padding: "2px",
            }}
          >
            <img
              src={item.image_path}
              alt={item.design}
              className="img-fluid"
            />

            <h2
              style={{
                fontSize: "10px",
                marginTop: "4px",
                marginBottom: "1px",
              }}
            >
              {item.design} {item.shade}
            </h2>
          </div>
        </div>
      ))
    )}
  </div>
            </div>

             </div>
          </div>

         <div className="row mt-4">
            <div className="col-md-4 col-md-myyy-table-4"> &nbsp; </div>
                <div className="col-md-8 col-12 col-md-myyy-table-8">
                      <CartList sizes={selectedProduct?.sizes || []} />
               </div>
          </div>
        </div>
      </section>
    </SkeletonTheme>
  );
}
export default ProductDetails;